module.exports = __webpack_public_path__ + "img/V2.fd249c41.png";